import React from 'react';
import audio1 from '../../../../assets/sounds/adult/de/SCR-A-078.mp3';
import incorrect1 from '../../../../assets/sounds/adult/de/SCR-A-079.mp3';
import correct1 from '../../../../assets/sounds/adult/de/SCR-A-062.mp3';
import audio2 from '../../../../assets/sounds/adult/de/SCR-A-new5.mp3';
import incorrect2 from '../../../../assets/sounds/adult/de/SCR-A-new6.mp3';
import correct2 from '../../../../assets/sounds/adult/de/SCR-A-062.mp3';
import starterTesten from '../../../../assets/sounds/adult/de/SCR-A-007.mp3';

export const starterTestenSound = starterTesten;

export const assignment1 = [
	{
		id: 1,

		mainSound: audio1,
		text: (
			<span
				style={{
					color: 'cyan',
					margin: 'auto',
					fontWeight: 'bold',
					fontSize: '22px',
				}}
			>
				{' '}
				zwicken{' '}
			</span>
		),
		choices: [
			{
				remark: false,
				word: 'drücken',
				comment: (
					<span>
						{' '}
						Das ist nicht richtig. Das richtige Wort ist:{' '}
						<span style={{color: 'orange'}}>kneifen</span>{' '}
					</span>
				),
				sound: incorrect1,
			},
			{
				remark: false,
				word: 'streicheln',
				comment: (
					<span>
						{' '}
						Das ist nicht richtig. Das richtige Wort ist:{' '}
						<span style={{color: 'orange'}}>kneifen</span>{' '}
					</span>
				),
				sound: incorrect1,
			},
			{
				remark: false,
				word: 'schlagen',
				comment: (
					<span>
						{' '}
						Das ist nicht richtig. Das richtige Wort ist:{' '}
						<span style={{color: 'orange'}}>kneifen</span>{' '}
					</span>
				),
				sound: incorrect1,
			},

			{
				remark: true,
				word: 'kneifen',
				comment: `Das ist richtig.`,
				sound: correct1,
			},
		],
	},
];


export const assignment2 = [
    {
        id: 2,
        mainSound: audio2,
        text: (
            <span
                style={{
                    color: 'cyan',
                    margin: 'auto',
                    fontWeight: 'bold',
                    fontSize: '22px',
                }}
            >
                {' '}
                Kompetenz{' '}
            </span>
        ),
        choices: [
            {
                remark: false,
                word: 'Wissen',
                comment: (
                    <span>
                        Das ist nicht richtig. Das richtige Wort ist{' '}
                        <span style={{color: 'orange'}}>
                            Fähigkeit
                        </span>
                    </span>
                ),
                sound: incorrect2,
            },
            {
                remark: false,
                word: 'Qualifikation',
                comment: (
                    <span>
                        Das ist nicht richtig. Das richtige Wort ist{' '}
                        <span style={{color: 'orange'}}>
                            Fähigkeit
                        </span>
                    </span>
                ),
                sound: incorrect2,
            },
            {
                remark: true,
                word: 'Fähigkeit',
                comment: 'Das ist richtig.',
                sound: correct2,
            },
            {
                remark: false,
                word: 'Unvermögen',
                comment: (
                    <span>
                        Das ist nicht richtig. Das richtige Wort ist{' '}
                        <span style={{color: 'orange'}}>
                            Fähigkeit
                        </span>
                    </span>
                ),
                sound: incorrect2,
            },
        ],
    },
];


export const assignments = [
	{
		id: 2,

		choices: [
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
		],
	},
	{
		id: 3,

		choices: [
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
			{
				word: 'knain',
				comment: '',
			},
		],
	},
	{
		id: 4,

		choices: [
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},

			{
				word: '',
				comment: '',
			},
		],
	},
	{
		id: 5,

		choices: [
			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},

			{
				word: '',
				comment: '',
			},
			{
				word: '',
				comment: '',
			},
		],
	},
];
